var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-icon',{attrs:{"name":"user-o","color":"#1989fa","size":"25px"},on:{"click":_vm.goMine}})
}
var staticRenderFns = []

export { render, staticRenderFns }